module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Backspace-0c62e8b721773e03c8b5c8226efff4f8.svg";